import { render, staticRenderFns } from "./NotifySchool.vue?vue&type=template&id=e837ae76&scoped=true"
import script from "./NotifySchool.vue?vue&type=script&lang=js"
export * from "./NotifySchool.vue?vue&type=script&lang=js"
import style0 from "./NotifySchool.vue?vue&type=style&index=0&id=e837ae76&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "e837ae76",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/home/gitlab-runner/builds/VsAMsifqL/0/hero/frontend/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('e837ae76')) {
      api.createRecord('e837ae76', component.options)
    } else {
      api.reload('e837ae76', component.options)
    }
    module.hot.accept("./NotifySchool.vue?vue&type=template&id=e837ae76&scoped=true", function () {
      api.rerender('e837ae76', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/views/notifySchool/NotifySchool.vue"
export default component.exports